const LogisticsTab = {
  data: () => ({
    logisticsItems: [{
      id: 0,
      title: '澄清公告',
      status: '19,25',
      supEnterpriseIds: 25210,
      bidType: 'purchase'
    }, {
      id: 1,
      title: '中标候选人公告',
      status: '8,31,32,33',
      supEnterpriseIds: 25210,
      bidType: 'houxuanNotice'
    }, {
      id: 2,
      title: '中标结果公告',
      status: '5,7,13,14',
      supEnterpriseIds: 25210,
      bidType: 'zhongbiaoNotice'
    }, {
      id: 3,
      title: '流标公告',
      status: 18,
      supEnterpriseIds: 25210,
      bidType: 'purchase'
    }, {
      id: 4,
      title: '企业公告',
      tenantid: 'paikhs6q'
    }]
  }),
  methods: {
    // onChange (e, that) {
    //   console.log(e)
    //   console.log(that.$refs.tabItem)
    // }
  }
}
export {
  LogisticsTab
}
